import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { UserInfoEffects } from '@appStore/account/effects/user-info.effects';
import { UserRegistrationEffects } from '@appStore/account/effects/user-registration.effects';
import { NotificationsEffects } from '@appStore/account/effects/notifications.effects';
import { SettingsEffects } from '@appStore/account/effects/settings.effects';
import { MessagesEffects } from '@appStore/account/effects/messages.effects';
import { WidgetEffects } from '@appStore/account/effects/widget.effects';
import { UserNotificationSettingsEffects } from '@appStore/account/effects/user-notification-settings.effects';
import { FilterViewSettingsEffects } from '@appStore/account/effects/filter-view-settings.effects';

export const effects: any[] = [
  UserInfoEffects,
  UserRegistrationEffects,
  NotificationsEffects,
  SettingsEffects,
  MessagesEffects,
  WidgetEffects,
  UserNotificationSettingsEffects,
  FilterViewSettingsEffects,
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class AccountEffectsModule {}
